module.exports = __webpack_public_path__ + "img/front_neck_depth.4121dc80.png";